import React from 'react';
import './Footer.css';
import SocialMediaIcons from '../SocialMediaIcons';
import featureFlags from '../../configuration/featureFlags';
import siteConfig from '../../configuration/siteConfiguration';

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section company-info">
          <div className="logo-container">
            <img src="companylogo.svg" alt="Cognitva.ai logo" className="footer-logo" />
          </div>
          <p>Powered by patent pending technology Cognitva CIP<sup>TM</sup>, Cognitva automates, adapts, and scales across industries -transforming how enterprises work.</p>
        </div>

        <div className="footer-section quick-links">
          <h3>QUICK LINKS</h3>
          <ul>
            <li className="home-link-item"><a href="/">Home</a></li>
            <li><a href="/cip">Cognitva CIP</a></li>
            <li><a href="/verticals-we-power">What we build</a></li>
            <li>
              <a href="/about-us">
                Who we are
                <span className="we-re-hiring">WE'RE HIRING</span>
              </a>
            </li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-section verticals-we-power">
          <h3>VERTICALS WE POWER</h3>
          <ul>
            <li><a href="/legal">Legal tech</a></li>
            <li><a href="#">Health tech</a></li>
            <li><a href="#">Financial services</a></li>
            <li><a href="#">ESG & Energy</a></li>
            <li><a href="#">Regulation tech</a></li>
          </ul>
        </div>

        <div className="footer-section safety-security">
          <h3>SAFETY & SECURITY</h3>
          <ul>
            <li><a href="/terms-of-user">Terms of user</a></li>
            <li><a href="/terms-of-user#privacy-policy">Privacy policy</a></li>
            <li><a href="/terms-of-user#cookies-policy">Cookies policy</a></li>
          </ul>
        </div>

        <div className="footer-certifications">
          <div className='footer-certifications-title'>Pioneering Innovation with</div>
          <div className="certificates-row">
            <img src={`${siteConfig.assetBaseUrl}/certificates/dpiit-startup.jpg`} alt="DPIIT Startup India" className="cert-dpiit-logo" />
            <img src={`${siteConfig.assetBaseUrl}/certificates/msme.jpg`} alt="MSME" className="cert-msme-logo" />
            <img src={`${siteConfig.assetBaseUrl}/certificates/anvesana-supported.jpg`} alt="Anvesana Supported" className="cert-anvesana-logo" />
            <img src={`${siteConfig.assetBaseUrl}/certificates/nvidia-incepted.jpg`} alt="NVIDIA Incepted" className="cert-nvidia-logo" />
          </div>
          {featureFlags.contactUs.showSocialMediaLinks && (
            <SocialMediaIcons />)}
        </div>
      </div>

      <div className="footer-bottom">
        <p>Copyright © 2025 Cognitva Global Technologies Private Limited | All rights reserved</p>
      </div>
    </footer>
  );
}

export default Footer;